/**
 * Performance Button Component
 * Toolbar button that toggles the performance widget
 */

import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { 
  Zap, 
  Activity,
  Settings
} from 'lucide-react';
import { PerformanceWidget } from './PerformanceWidget';
import { usePerformanceMonitoring } from '@/hooks/usePerformanceMonitoring';
import { cn } from '@/lib/utils';

export function PerformanceButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [useSuperSaiyanLabels, setUseSuperSaiyanLabels] = useState(true);
  const { metrics } = usePerformanceMonitoring();
  
  // Calculate overall health status for badge
  const healthScore = 85; // This would come from the health calculation logic
  const isGoodHealth = healthScore >= 75;
  
  return (
    <>
      <div className="relative">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setIsOpen(!isOpen)}
          className={cn(
            "h-10 px-3 gap-2 transition-all duration-200",
            isOpen && "bg-accent text-accent-foreground"
          )}
        >
          <Zap className={cn(
            "h-4 w-4",
            isGoodHealth ? "text-green-500" : "text-yellow-500"
          )} />
          <span className="hidden sm:inline">Performance</span>
          <Badge 
            variant={isGoodHealth ? "default" : "destructive"}
            className="text-xs px-1.5 py-0 h-5"
          >
            {healthScore}%
          </Badge>
        </Button>
        
        {/* Settings indicator */}
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6 absolute -top-1 -right-1 bg-muted rounded-full p-0.5"
          onClick={(e) => {
            e.stopPropagation();
            setUseSuperSaiyanLabels(!useSuperSaiyanLabels);
          }}
        >
          <Settings className="h-3 w-3 text-muted-foreground hover:text-foreground" />
        </Button>
      </div>

      <PerformanceWidget 
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        useSuperSaiyanLabels={useSuperSaiyanLabels}
      />
    </>
  );
}